module.exports = __webpack_public_path__ + "static/img/banner.f574acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serie_a/banner.png
// module id = BSji
// module chunks = 1